import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
// HeartIcon replaced by the Ishira brain logo image
// import { HeartIcon } from '../assets/icons/Icons';
import '../styles/navbar.css';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (!mobileOpen) return;
    const handleClickOutside = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setMobileOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [mobileOpen]);

  const closeMobile = () => setMobileOpen(false);

  const handleScrollLink = (anchor) => {
    closeMobile();
    if (isHome) {
      document.getElementById(anchor)?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/');
      setTimeout(() => {
        document.getElementById(anchor)?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`} ref={navRef}>
      <div className="container">
        <Link to="/" className="logo" onClick={closeMobile}>
          <img
            src="/ishira-logo.png"
            alt="Ishira"
            className="logo-img"
          />
          <span className="logo-lockup">
            <span className="logo-text">Ishira</span>
            <span className="logo-tagline">The Mind Clinic</span>
          </span>
        </Link>
        <ul className={`nav-links ${mobileOpen ? 'mobile-open' : ''}`}>
          <li><a href="#services" onClick={(e) => { e.preventDefault(); handleScrollLink('services'); }}>Services</a></li>
          <li><a href="#doctors" onClick={(e) => { e.preventDefault(); handleScrollLink('doctors'); }}>Doctors</a></li>
          <li><a href="#resources" onClick={(e) => { e.preventDefault(); handleScrollLink('resources'); }}>Resources</a></li>
          <li><a href="#faq" onClick={(e) => { e.preventDefault(); handleScrollLink('faq'); }}>FAQ</a></li>
          <li><Link to="/contact" onClick={() => { closeMobile(); window.scrollTo(0, 0); }}>About</Link></li>
          {/* Phase-1 launch: login disabled */}
          {/* <li><Link to="/login" onClick={closeMobile}>Login</Link></li> */}
          <li>
            <a
              href="https://book.healthplix.com/dr-doctor-s-name-specialisation-place-city_198213"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-cta"
              onClick={closeMobile}
            >
              Book a session
            </a>
          </li>
        </ul>
        <button
          className={`mobile-toggle ${mobileOpen ? 'active' : ''}`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle navigation"
        >
          <span /><span /><span />
        </button>
      </div>
    </nav>
  );
};

export default Navbar;